(() => {
  if (window.__awPageSeriesSucrubLoaded) {
    return;
  }

  window.__awPageSeriesSucrubLoaded = true;

  const instances = new Map();
  const selectors = {
    root: "[data-aw-page-series-sucrub]",
    scroll: "[data-aw-page-series-sucrub-scroll]",
    scrollbar: "[data-aw-page-series-sucrub-scrollbar]",
    thumb: "[data-aw-page-series-sucrub-scrollbar-thumb]",
    wrapper: ".rte__table-wrapper",
  };

  class AWPageSeriesSucrub {
    constructor(root) {
      this.root = root;
      this.scrolls = Array.from(root.querySelectorAll(selectors.scroll));
      this.scroll = null;
      this.scrollbar = root.querySelector(selectors.scrollbar);
      this.thumb = root.querySelector(selectors.thumb);
      this.viewport = null;
      this.rafId = null;
      this.resizeObserver = null;
      this.mutationObserver = null;

      this.onScroll = this.requestUpdate.bind(this);
      this.onResize = this.update.bind(this);
      this.onMutate = this.handleMutations.bind(this);

      if (!this.scrolls.length || !this.scrollbar || !this.thumb) {
        return;
      }

      this.refreshViewport();
      this.bindEvents();
      this.update();
    }

    getActiveScroll() {
      return (
        this.scrolls.find((scroll) => {
          const styles = window.getComputedStyle(scroll);
          return styles.display !== "none" && scroll.offsetParent !== null;
        }) || this.scrolls[0]
      );
    }

    getViewport() {
      const activeScroll = this.getActiveScroll();
      this.scroll = activeScroll;

      if (!activeScroll) {
        return null;
      }

      return activeScroll.querySelector(selectors.wrapper) || activeScroll;
    }

    refreshViewport() {
      const nextViewport = this.getViewport();

      if (nextViewport === this.viewport) {
        return;
      }

      if (this.viewport) {
        this.viewport.removeEventListener("scroll", this.onScroll);
      }

      this.viewport = nextViewport;

      if (this.viewport) {
        this.viewport.addEventListener("scroll", this.onScroll, { passive: true });
      }

      if (this.resizeObserver && this.viewport) {
        this.resizeObserver.observe(this.viewport);
      }
    }

    bindEvents() {
      if ("ResizeObserver" in window) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.root);
        this.scrolls.forEach((scroll) => {
          this.resizeObserver.observe(scroll);
        });

        if (this.viewport) {
          this.resizeObserver.observe(this.viewport);
        }

        this.scrolls.forEach((scroll) => {
          const table = scroll.querySelector("table");
          if (table) {
            this.resizeObserver.observe(table);
          }
        });
      } else {
        window.addEventListener("resize", this.onResize);
      }

      this.mutationObserver = new MutationObserver(this.onMutate);
      this.scrolls.forEach((scroll) => {
        this.mutationObserver.observe(scroll, {
          childList: true,
          subtree: true,
        });
      });
    }

    handleMutations() {
      this.refreshViewport();
      this.requestUpdate();
    }

    requestUpdate() {
      if (this.rafId) {
        return;
      }

      this.rafId = window.requestAnimationFrame(() => {
        this.rafId = null;
        this.update();
      });
    }

    update() {
      this.refreshViewport();

      const viewport = this.viewport || this.scroll;

      if (!viewport) {
        this.scrollbar.classList.add("is-hidden");
        return;
      }
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const canScroll = maxScroll > 1;

      this.scrollbar.classList.toggle("is-hidden", !canScroll);

      if (!canScroll) {
        this.thumb.style.width = "0";
        this.thumb.style.transform = "translateX(0)";
        return;
      }

      const trackWidth = this.scrollbar.clientWidth;
      const thumbWidth = Math.max(24, trackWidth * (viewport.clientWidth / viewport.scrollWidth));
      const maxThumbOffset = Math.max(0, trackWidth - thumbWidth);
      const progress = Math.min(Math.max(viewport.scrollLeft / maxScroll, 0), 1);
      const thumbOffset = maxThumbOffset * progress;

      this.thumb.style.width = `${thumbWidth}px`;
      this.thumb.style.transform = `translateX(${thumbOffset}px)`;
    }

    destroy() {
      if (this.rafId) {
        window.cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      if (this.viewport) {
        this.viewport.removeEventListener("scroll", this.onScroll);
      }

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      } else {
        window.removeEventListener("resize", this.onResize);
      }

      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
      }
    }
  }

  function initAll(container = document) {
    container.querySelectorAll(selectors.root).forEach((root) => {
      if (instances.has(root)) {
        instances.get(root).update();
        return;
      }

      instances.set(root, new AWPageSeriesSucrub(root));
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();
